import React, { ComponentProps, useContext } from 'react'
// Components
import TableLoader from 'components/utils/Table/Table'
// Styles
import * as R from './Table.styles'
// Additional
import { Tab } from 'static/tabs'
import { AvailableColumns, Settings } from './Table.settings'
import { TournamentContext } from 'components/Tournament/__Tournament.context'
import { SportsmanRecord } from 'data/SportsmanRecord'
import { AppContext } from 'App'
import { Data } from 'helpers/data'
import { SportContext } from 'components/Sports/__Sports.context'

const DEFAULT_COLUMNS = [
  'nickname',
  'country',
  'isApproved',
  'isFrozen',
  'is_popular',
  'ctaButton',
] as Array<AvailableColumns>

const FILTER_COLUMNS = [
  'nickname',
  'country',
  'isApproved',
  'is_popular',
] as Array<AvailableColumns>

interface Props extends Pick<ComponentProps<typeof TableLoader>, 'onSelect'> {}

const Table: React.FC<Props> = (p) => {
  const { db: a_db, alert: a_alert } = useContext(AppContext)

  const { params: t_params } = useContext(TournamentContext)
  const { params: s_params } = useContext(SportContext)

  const loadData = async () => {
    if (s_params?.sport_id)
      return await Data.getSportsmenBySportId(a_db!, s_params?.sport_id, {
        alert: a_alert,
      })

    if (t_params?.tournament_id)
      return await Data.getSportsmenByTournamentId(
        a_db!,
        t_params?.tournament_id,
        { alert: a_alert }
      )

    return await Data.getAllSportsmen(a_db!, { alert: a_alert })
  }

  const useAsFilterView = Boolean(p.onSelect)

  return (
    <TableLoader<SportsmanRecord>
      reloadFrom={[Tab.Sportsmen]}
      loadDataFn={loadData}
      settings={Settings(useAsFilterView ? FILTER_COLUMNS : DEFAULT_COLUMNS, {
        disableNew: Boolean(t_params?.tournament_id),
      })}
      // @ts-ignore
      onSelect={p.onSelect}
      disableChangeUrl
      style={{
        thead: R.TableHeadStyle,
        theadH: R.TableCellStyle,
        theadR: R.GetTableRowStyle(),
        tbodyR: R.GetTableRowStyle(useAsFilterView),
        tbodyD: R.TableCellStyle,
      }}
    />
  )
}

export default Table
